import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "KVM and the great outdoors",
  "description": "",
  "published": "2011-09-11T00:00:00.000Z",
  "redirect_from": ["/blog/kvm-and-the-great-outdoors/swizec/2429"],
  "categories": "Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/09/300px-Interior_albin_brag_kvm_1.jpg",
        "alt": "albin brag KVM köping, interior jugend cottage...",
        "title": "albin brag KVM köping, interior jugend cottage..."
      }}></img></p>
    <p>{`For the past few days I've been working on a paper about `}<a parentName="p" {...{
        "href": "http://www.symantec.com/business/solutions/solutiondetail.jsp?solid=sol_business_cont&solfid=sol_virtualization_management",
        "title": "hardware virtualization"
      }}>{`virtualization`}</a>{` and linux. Today I finally came to the good meaty parts that are beyond just describing what virtualization is and what different kinds we know and I was deeply impressed with the magic that linux supports.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.linux-kvm.org/",
        "title": "Kernel-based Virtual Machine"
      }}>{`KVM`}</a>{` is something you should really look up. The internet at large is a little scarce on the details about what's actually going on, focusing instead on the insane speed improvements and simplifications. Which is a shame because it hides how truly epic this technology is - I for one am deeply ashamed I haven't known of this before.`}</p>
    <p>{`I was able to track down the `}<a parentName="p" {...{
        "href": "http://www.linuxinsight.com/files/kvm_whitepaper.pdf"
      }}>{`original whitepaper about KVM`}</a>{` from `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Qumranet",
        "title": "Qumranet"
      }}>{`Qumranet`}</a>{` (the startup that worked on this before selling out to `}<a parentName="p" {...{
        "href": "http://www.redhat.com",
        "title": "Red Hat"
      }}>{`Red Hat`}</a>{`). Basically it seems the idea behind KVM is to merge the hypervisor and `}<a parentName="p" {...{
        "href": "http://www.kernel.org/",
        "title": "Linux kernel"
      }}>{`linux kernel`}</a>{` so that `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Virtual_machine",
        "title": "Virtual machine"
      }}>{`virtual machines`}</a>{` are nothing more than normal processes running on the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Host_machine",
        "title": "Host machine"
      }}>{`host machine`}</a>{`.`}</p>
    <p>{`This means that the awesome linux scheduler and `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Memory_management",
        "title": "Memory management"
      }}>{`memory management`}</a>{` can handle virtual machines as well and greatly reduces the complexity of everything. And you can even use kill to close virtual machines and pretty much your standard process management tools work perfectly.`}</p>
    <p>{`Sometime soon I'm going to have to install this thing and see what it's like first hand.`}</p>
    <p>{`Oh and another thing I discovered today is that being cooped up in my room all day every day because I'm studying for exams is starting to wear on me. Today I wanted desperately to do some sports outside, but since I left my rollerblades in the US ... I couldn't. There was nothing to do! Nothing! Such pretty weather we had as well ...`}</p>
    <p>{`And I haven't coded anything in two weeks either, that's pretty horrible on its own.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://dtrace.org/blogs/bmc/2011/08/15/kvm-on-illumos/"
        }}>{`KVM on Illumos (OpenSolaris fork)`}</a>{` (dtrace.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.pcworld.com/article/239767/the_virtualization_path_less_traveled.html"
        }}>{`The Virtualization Path Less Traveled`}</a>{` (pcworld.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://cartesianproduct.wordpress.com/2011/07/31/kvm-starting-the-default-network/"
        }}>{`KVM: starting the 'default' network`}</a>{` (cartesianproduct.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=bf8e45f3-5056-442d-950c-99002ce08002",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      